import { render } from "./Nbus_mainpage.vue?vue&type=template&id=79bcdfda&scoped=true"
import script from "./Nbus_mainpage.vue?vue&type=script&lang=js"
export * from "./Nbus_mainpage.vue?vue&type=script&lang=js"

import "./Nbus_mainpage.vue?vue&type=style&index=0&id=79bcdfda&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bcdfda"]])

export default __exports__